import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { DmpLogo } from '../brand/DmpLogo';
interface CngQrStickerProps {
  qrId: string;
  reg: string;
  size?: 'md' | 'sm';
  voided?: boolean;
  label?: string;
}
export function CngQrSticker({
  qrId,
  reg,
  size = 'md',
  voided,
  label = 'CNG'
}: CngQrStickerProps) {
  const sm = size === 'sm';
  return <div className={`relative flex flex-col overflow-hidden rounded-xl border-2 border-navy-800 bg-white shadow-sm ${sm ? 'w-[150px]' : 'w-[240px]'}`} data-id="element-2200" data-mp="f4vrm30awgx7">
      <div className={`flex items-center gap-2 bg-navy-800 text-white ${sm ? 'px-2 py-1.5' : 'px-3 py-2.5'}`} data-id="element-2201" data-mp="o2fx5o574zdm">
        <DmpLogo size={sm ? 22 : 34} data-id="element-2202" data-mp="t33k9yqb0w2k" />
        <div className="leading-tight" data-id="element-2203" data-mp="y1n7s3kjqfx1">
          <p className={`font-semibold ${sm ? 'text-[8px]' : 'text-[11px]'}`} data-id="element-2204" data-mp="y0lv5unvtld7">ঢাকা মেট্রোপলিটন পুলিশ</p>
          <p className={`font-mono font-bold tracking-widest text-gold ${sm ? 'text-[9px]' : 'text-sm'}`} data-id="element-2205" data-mp="2uuysg4dcqig1">DMP</p>
        </div>
      </div>
      <div className={`flex items-center justify-between bg-bdgreen-600 text-white ${sm ? 'px-2 py-0.5' : 'px-3 py-1'}`} data-id="element-2206" data-mp="2zv4dv2t138po">
        <span className={`font-mono font-extrabold tracking-[0.2em] ${sm ? 'text-xs' : 'text-xl'}`} data-id="element-2207" data-mp="3u7od9bb6xgll">{label}</span>
        <span className={`${sm ? 'text-[7px]' : 'text-[10px]'}`} data-id="element-2208" data-mp="3p824be2eamil">যানবাহন যাচাই</span>
      </div>
      <div className={`flex justify-center ${sm ? 'p-2' : 'p-4'}`} data-id="element-2209" data-mp="3ka0kus124l6l">
        <QRCodeSVG value={`https://verify.dmp.gov.bd/q/${qrId}`} size={sm ? 96 : 168} level="H" fgColor="#081c3d" data-id="element-2210" data-mp="3k7nsdkxoasfa" />
      </div>
      <div className={`border-t border-dashed border-navy-200 text-center ${sm ? 'px-2 pb-2 pt-1' : 'px-3 pb-3 pt-2'}`} data-id="element-2211" data-mp="gt1mre0s6w94">
        <p className={`font-mono font-bold tracking-wider text-navy-900 ${sm ? 'text-[10px]' : 'text-base'}`} data-id="element-2212" data-mp="bsnnakd8wump">{qrId}</p>
        <p className={`font-semibold text-navy-800 ${sm ? 'text-[9px]' : 'text-sm'}`} data-id="element-2213" data-mp="7rk6nvndiukf">{reg}</p>
        {!sm && <p className="mt-1 text-[10px] text-slate-500" data-id="element-2214" data-mp="2wlhb082d00ce">ট্রাফিক পুলিশ যাচাইয়ের জন্য স্ক্যান করুন</p>}
      </div>
      <div className="flex h-1.5" data-id="element-2215" data-mp="2skfalnwphi8u">
        <span className="flex-1 bg-bdgreen-600" data-id="element-2216" data-mp="2tzrhfj678mhe" />
        <span className="w-6 bg-flagred" data-id="element-2217" data-mp="2u01a5eimp7qs" />
        <span className="flex-1 bg-bdgreen-600" data-id="element-2218" data-mp="2yyb3rkopg0aa" />
      </div>
      {voided && <div className="absolute inset-0 flex items-center justify-center bg-white/70" data-id="element-2219" data-mp="2yw8e51rgs963">
          <span className="-rotate-12 rounded border-4 border-red-600 px-3 py-1 text-lg font-bold text-red-600" data-id="element-2220" data-mp="2k3em6gv0a0kj">বাতিল</span>
        </div>}
    </div>;
}